import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(LocalizedFormat)

export function formatDate(date: string | number | Date, format: string) {
    return dayjs(date).format(format)
}
